import { RecordContextProvider } from 'react-admin';
import {
  EmbeddedFunctionField,
  FunctionField,
  FunctionFieldProps,
} from 'shared/react-admin/Fields';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { Gateway } from 'types/embedded/gateway';
import { Order } from 'types/embedded/order';

type Props = Omit<FunctionFieldProps, 'render'>;

export const OrderAdjustmentsProviderField: React.FC<Props> = (props) => {
  return (
    <FunctionField
      render={(record: Order) => {
        return (
          <RecordContextProvider value={record}>
            <ReferenceField link={false} reference="gateways" source="gateway.@id">
              <FunctionField
                render={(record: Gateway) => {
                  return (
                    <RecordContextProvider value={record}>
                      <EmbeddedFunctionField sourceField="provider.name" />
                    </RecordContextProvider>
                  );
                }}
                source="provider.@id"
              />
            </ReferenceField>
          </RecordContextProvider>
        );
      }}
      {...props}
    />
  );
};
